import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
    labelWrapper: {
        width: '100%',
        display: 'block',
        '&.disabled': {
            opacity: 0.1,
            '& input': {
                opacity: 0.2,
            },
        },
    },
    labelInput: {
        borderRadius: theme.borderRadius,
        backgroundColor: '#ffffff',
        border: 'none',
        boxShadow: 'none',
        padding: '8px 20px 7px 20px',
        width: '100%',
        boxSizing: 'border-box',
        fontSize: 16,
        '&::placeholder': {
            color: '#6f6f6f',
            fontSize: '18px',
            fontStyle: 'italic',
            fontWeight: 300,
            lineHeight: 'normal',
            letterSpacing: '0.5px',
        },
        '&:active': {
            outline: 'none',
        },
        '&:focus': {
            outline: 'none',
        },
    },

    labelParagraph: {
        marginBottom: 10,
        marginTop: 20,

        '@media (max-width: 769px)': {
            marginTop: 15,
        },
    },
}))

// const BookingFormInput = ({
//   labelText,
//   inputName,
//   inputType,
//   placeholder
// }) => {
const BookingFormInput = props => {
    const classes = useStyles()
    return (
        <label
            htmlFor={props.name}
            className={`${classes.labelWrapper} ${props.disabled && 'disabled'}`}
        >
            {/*{labelText !== undefined && (*/}
            {/*  <p className={classes.labelParagraph}>*/}
            {/*    <strong>{labelText}</strong>*/}
            {/*  </p>*/}
            {/*)}*/}
            <input
                placeholder={props.placeholder}
                className={classes.labelInput}
                type={props.type}
                name={props.name}
                value={props.promo}
                onChange={props.promoChange}
                disabled={props.disabled}
            />
        </label>
    )
}

// BookingFormInput.propTypes = {
//   labelText: PropTypes.string,
//   inputName: PropTypes.string,
//   inputType: PropTypes.string,
// }

export default BookingFormInput
